<template>
  <div class="animated fadeIn">
  
    <b-card-body>
      <b-row>
        <b-col sm xs="12" class="text-left mt-3" >
          <router-link :to="'/guichets/create/agence/' + agence_id" v-if="can('guichet-create')">
            <b-button variant="primary" class="btn-pill">
              <i class="fa fa-plus"></i>&nbsp;Nouveau
            </b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card-body>
    <b-row>
      <b-col lg="12">
        <!--<c-table-entities striped caption="<i class='fa fa-align-justify'></i> Liste des entités"></c-table-entities>-->
        <div>
          <vue-good-table :columns="columns" styleClass="vgt-table condensed bordered striped" :rows="rows" :fixed-header="false" :pagination-options="pagination" :search-options="search" :totalRows="totalRecords" mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter">
            <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">                       
                              <b-dropdown id="ddown-sm-split" size="sm" text="Plus de détails" class="m-2">
                                <div role="group" aria-lableledby="header1">                   
                                    <router-link :to="'/guichets/edit/' + props.row.id" v-if="can('guichet-edit')"><b-dropdown-item-button aria-describedby="header1" :id="props.row.id"><i class="fa fa-edit"></i> Modifier</b-dropdown-item-button></router-link>
                                        <!-- <b-dropdown-item-button aria-describedby="header1" v-if="can('guichet-delete')" @click.prevent="confirm()"><i class="fa fa-trash"></i> Désactiver</b-dropdown-item-button>
                                    <router-link :to="'/guichets/show/' + props.row.id" v-if="can('guichet-show')"><b-dropdown-item-button aria-describedby="header1"><i class="fa fa-eye"></i> Plus d'infos</b-dropdown-item-button></router-link> -->
                                </div>
                                <div role="group" aria-lableledby="header2">
                                  <b-dropdown-header id="header2">Autres actions ...</b-dropdown-header>
                                   <router-link :to="'/historique/guichet/'+ props.row.id">
                                      <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-users"></i> Historique des activités</b-dropdown-item-button>
                                    </router-link>
                                   <router-link :to="'/approvisionnements/guichet/list/'+ props.row.id" v-if="can('approvisionnement-list-by-guichet')">
                                      <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Approvisionnements</b-dropdown-item-button>
                                    </router-link>
                                    <router-link :to="'/transferts/list/guichet/'+ props.row.id" v-if="can('operation-list-by-guichet')">
                                      <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Transferts</b-dropdown-item-button>
                                    </router-link>
                                    <!--<router-link :to="'operations/paiement_masse/guichet/create/'+ props.row.id" >
                                      <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Paiement de masse</b-dropdown-item-button>
                                    </router-link>-->
                                    <router-link :to="'/plannings/guichet/list/'+ props.row.id" v-if="can('planning-list-by-guichet')">
                                      <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Plannings</b-dropdown-item-button>
                                    </router-link>
                                  <!--<b-dropdown-item-button aria-describedby="header2">Delete</b-dropdown-item-button>-->
                                </div>
                              </b-dropdown>
                               <!-- <b-modal ref="myModalRef" hide-footer centered title="Confirmation de la désativation">
                                  <div class="d-block text-center">
                                    <p style>Etes vous certain de vouloir désactiver ce guichet ?</p>
                                    <h5>Voulez-vous continuer ?</h5>
                                  </div>
                                  <b-btn class="mt-3 col-lg-6" variant="outline-danger"  @click="cancel_delete">Annuler</b-btn>
                                  <b-btn class="mt-3 col-lg-6" variant="outline-success" >Valider</b-btn>
                                </b-modal> -->
                        </span>
                        <span v-else style="font-size: 0.875rem;">
                          {{props.formattedRow[props.column.field]}}
                        </span>
                    </template>
              </vue-good-table>
          </div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>
</template>

<script>
  //import cTableEntities from './TableEntities.vue'
  import {
    VueGoodTable
  } from 'vue-good-table';
  import {
    mapState,
    mapActions
  } from 'vuex';
  export default {
    name: 'tables',
    //components: {cTableEntities},
    components: {
      VueGoodTable
    },
    data() {
      return {
        totalRecords :0,
        columns: [{
            label: 'Agence',
            field: 'agence_nom',
            filterable: true,
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Ville',
            field: 'agence_ville',
            filterable: true,
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Nom',
            field: 'nom',
            filterable: true,
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Solde',
            field: 'solde',
            type: 'number',
            filterable: true,
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Enregistré le',
            field: 'created_at',
            type: 'date',
            dateInputFormat: 'YYYY-MM-DD',
            dateOutputFormat: 'YYYY-MM-DD',
            filterable: true,
            formatFn: this.formatFn,
            thClass: 'custom-th-class',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Action',
            field: 'btn',
            html: true,
            width: '150px',
          }
        ],
        rows: [],
        pagination: {
          enabled: true,
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [3, 5, 10, 50, 100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        },
        search: {
          enabled: true,
          trigger: 'keyup',
          placeholder: 'Rechercher dans la table',
        },
        serverParams: {
          agence_nom:'',
          nom:'',
          solde:'',
          agence_id:'',
          created_at:'',
          page:1,
          current_page: 1,
          nb_lines: 10
        },
        agence_id:''
      };
    },
    computed: mapState({
      agencies: state => state.atm.all
    }),
    created() {
      
      
    },
    methods: {
      formatFn: function (value) {
          return value != null ? value : null
      },
       hideModal () {
      this.$refs.myModalRef.hide()
      },
      async cancel_delete(){
          this.hideModal()
      },
      async confirm(){
          this.$refs.myModalRef.show()
      },
      // async get_all_atms() {
      //   this.agence_id = this.$route.params.agence_id
      //   this.$store.dispatch('atm/get_all_atms_by_agency',this.$route.params.agence_id).then(()=>{
      //     return this.rows = store.getters['atm/rows'];
      //   })
      // },
      can(perm){
            return store.getters['auth/can'](perm)
        },
      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
      onPageChange(params) {
        this.serverParams.page = params.currentPage
        this.updateParams({page: params.currentPage,current_page: params.currentPage});
        this.loadItems();
      },
      onPerPageChange(params) {
        
        console.log(params)
        this.serverParams.nb_lines = params.currentPerPage
        this.updateParams({page: params.currentPage,paginate:params.currentPerPage});
        this.loadItems();
      },

      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params.sortType,
            field: this.columns[params.columnIndex].field,
          },
        });
        this.loadItems();
      },    
      onColumnFilter(params) {
        this.serverParams.agence_nom=params.columnFilters.agence_nom,
        this.serverParams.agence_ville=params.columnFilters.agence_ville,
        this.serverParams.nom=params.columnFilters.nom,
        this.serverParams.solde=params.columnFilters.solde,
        this.serverParams.created_at=params.columnFilters.created_at,
        this.updateParams(params);
        this.loadItems();
      },
      // load items is what brings back the rows from server
      loadItems() {
        //console.log('server params ',this.serverParams)
        this.serverParams.agence_id=this.$route.params.agence_id,
        this.agence_id=this.$route.params.agence_id,
        this.$store.dispatch('atm/get_all_atms_by_agency',this.serverParams).then((response)=>{
          this.totalRecords = response.total;
          return this.rows = store.getters['atm/rows'];
        })
      }
    },
    mounted() {
      this.loadItems()
      //this.get_all_atms()
    }
  
  }
</script>
